import React, { useContext, useState } from 'react';

import { ThemeContext, ThemeProvider as Theme } from 'styled-components';

import { darkTheme, lightTheme } from '@styles/theme';
import { SkeletonTheme } from 'react-loading-skeleton';

interface DefaultTheme {
  defaultTheme: string;
}

export interface ThemeData {
  changeTheme(): void;
  theme: 'light' | 'dark';
  defaultTheme(): void;
}

export const useTheme = (): ThemeData => {
  const theme = useContext(ThemeContext);
  return theme || {};
};

type Theme = 'dark' | 'light';

export const ThemeProvider: React.FC = ({ children }) => {
  const [theme, setTheme] = useState(() => {
    const user = localStorage.getItem('user');
    const savedThemeUser = JSON.parse(user as string);
    let savedTheme;

    if (savedThemeUser) {
      savedTheme = savedThemeUser.defaultTheme;
    } else {
      savedTheme = sessionStorage.getItem('theme');
    }

    if (savedTheme) {
      return savedTheme;
    }
    return 'dark';
  });

  const changeTheme = (handleTheme?: 'light' | 'dark') => {
    if (handleTheme) {
      setTheme(handleTheme);
    }
    if (theme === 'light') {
      setTheme('dark');
      sessionStorage.setItem('theme', 'dark');
    } else {
      setTheme('light');
      sessionStorage.setItem('theme', 'light');
    }
  };

  const defaultTheme = () => {
    setTheme(theme);
  };

  return (
    <ThemeContext.Provider value={{ changeTheme, theme, defaultTheme }}>
      <Theme theme={theme === 'light' ? lightTheme : darkTheme}>
        <SkeletonTheme
          color={theme === 'light' ? lightTheme.skeleton : darkTheme.skeleton}
        >
          {children}
        </SkeletonTheme>
      </Theme>
    </ThemeContext.Provider>
  );
};
